import { render, staticRenderFns } from "./BusinessHoursTable.vue?vue&type=template&id=32732f5c&"
import script from "./BusinessHoursTable.vue?vue&type=script&lang=ts&"
export * from "./BusinessHoursTable.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessHoursTable.vue?vue&type=style&index=0&id=32732f5c&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QCheckbox} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCheckbox})
